import React from 'react';
import PropTypes from 'prop-types';
import * as rights from '../../../../model/rights';
import GenericRow from './GenericRow';

class PermissionsRow extends GenericRow {
  constructor(props) {
    super(props);
  }

  render() {
    return <div className={'row col-md-12'}>
      <div className={'col-md-4'} style={{marginTop: '12px'}}>
        <div style={this.getColumnStyle()}>
          <span>PERMISSIONS</span>
        </div>
      </div>
      <div className={'col-md-8'}>
        {this.getTableDataContent(rights.PERMISSIONS_READ_PRIVILEGE)}
        {this.getEmptyDataContent()}
        {this.getTableDataContent(rights.PERMISSIONS_EDIT_PRIVILEGE)}
        {this.getEmptyDataContent()}
        {this.getEmptyDataContent()}
        {this.getEmptyDataContent()}
      </div>
    </div>;
  }
}

PermissionsRow.propTypes = {
  permissionSection: PropTypes.object,
  onChange: PropTypes.func,
};

export default PermissionsRow;
